import { render, staticRenderFns } from "./PrintingSets.vue?vue&type=template&id=0560a392&"
import script from "./PrintingSets.vue?vue&type=script&lang=js&"
export * from "./PrintingSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports